import React, { useEffect, useMemo, useState } from "react";
/** @jsxImportSource @emotion/react */
import tw, { styled } from "twin.macro";
import {
	// Alert,
	Button,
	Empty,
	Image,
	Input,
	message,
	Modal,
	Popconfirm,
	Upload,
} from "antd";
import MainLayout from "../../components/MainLayout/MainLayout";
import jumbo from "../../assets/images/story_jumbo.jpeg";
import plus from "../../assets/svg/plus.svg";
import {
	btnStyle,
	hideScrollbar,
	LandingTitle,
} from "../../lib/styles/styleLibrary";
import {
	addStoryContent,
	fetchCoupleData,
	// updateStoryContent,
} from "../../redux/actions/wedding";
import { imgToBase64, isEmpty, Toast } from "../../lib/helpers/helpers";
import dayjs from "dayjs";
import API_MAP from "../../services/uri";
import axios from "axios";
import { EmptyData, Loading, PageLoading } from "../../components";
import { Prompt } from "react-router";
import { v4 as uuid_v4 } from "uuid";
import fallback from "../../assets/images/fallback.jpeg";
import del from "../../assets/svg/del2.png";
import edit from "../../assets/svg/edit.png";
import upload from "../../assets/svg/upload3.png";
// import { TextLoop } from "react-text-loop-next";
import { useQuery } from "react-query";
import Auth from "../../lib/middleware/auth";

const StoryWrapper = styled.div`
	${tw`p-4 md:p-12 h-full overflow-y-scroll`};
	width: 70%;

	.ant-upload-picture-card-wrapper {
		${tw`flex! flex-row! flex-wrap w-full md:w-40`};
	}

	.ant-upload.ant-upload-select-picture-card {
		${tw`flex! flex-row! flex-wrap border-none!`};
		width: inherit !important;
		height: inherit !important;
	}

	.couple-name {
		background: #fefeff;
		box-shadow: 0px 20px 20px rgba(90, 90, 90, 0.1);
		backdrop-filter: blur(21.7463px);
		border-radius: 20px;
	}
	@media (max-width: 1217px) {
		width: 100%;
	}

	.jumbotron {
		background-color: #00000033;
		background-blend-mode: overlay !important;
		background-size: 100% 100% !important;
		background-position: center !important;
		background-repeat: no-repeat !important;
		border-radius: 18px;
		height: 15.6rem;

		.inner-cont {
			background: #323232;
			opacity: 0.7;
			box-shadow: 0px 8px 20px rgba(74, 210, 228, 0.0818127);
			backdrop-filter: blur(27.1828px);
			border-radius: 7px;
		}
	}

	.btnStyle {
		font-size: 0.75rem;
		font-family: "Poppins";
		border: "1px solid #f4f4f8" !important;
	}
`;

const EditStyle = styled.div`
	${({ hasBorder }) =>
		hasBorder &&
		tw`border-2 border-dashed border-appPinkSaturated p-4 opacity-100 relative rounded-2xl m-3`};
`;

const OurStory = (props) => {
	const { data: coupleData, refetch } = useQuery("wedding", fetchCoupleData, {
		refetchOnWindowFocus: false,
		// refetchOnmount: true,
	});
	const coupleLocal = Auth.getCouple();
	const couple = coupleData?.data || coupleLocal;

	const { TextArea } = Input;
	const coupleStory = useMemo(() => couple?.story, [couple?.story]);
	// console.log(coupleStory);
	const [story, setStory] = useState([]);
	const [newStory, setNewStory] = useState(story);

	useEffect(() => {
		setStory(coupleStory);
		setNewStory(coupleStory);
	}, [coupleStory]);
	// console.log("====== Our Story ======\n", story);

	useEffect(() => {}, [newStory]);
	// console.log("====== New story array=======\n", newStory);

	// Fallback image Url
	const fallbackString = imgToBase64(fallback);

	const bigDate = dayjs(couple?.date).format("DD/MM/YY");
	const weddingID = couple?.id;

	const [visible, setVisible] = useState(false);
	const [editVisible, setEditVisible] = useState(false);

	const handleCancel = () => {
		setVisible(false);
	};

	const showEditModal = () => {
		setEditVisible(true);
	};

	const handleEditCancel = () => {
		setEditVisible(false);
	};

	// Upload Cover Photo
	const [defaultFileList, setDefaultFileList] = useState([]);
	const [showupload, setShowUpload] = useState(true);

	const handleFileChange = ({ fileList }) => {
		// Processing file Change, guaranteed that the user selected by one is only one
		setDefaultFileList(fileList);
	};

	const handleUpload = async (options) => {
		const { onSuccess, onError, file } = options;
		if (isEmpty(defaultFileList)) {
			message.warning("Please select the file you want to upload");
		}
		if (isEmpty(weddingID)) {
			Toast.fire({
				icon: "error",
				title: "Cant upload cover photo, wedding ID not found",
			});
		}
		const formData = new FormData();
		const config = {
			headers: { "content-type": "multipart/form-data" },
		};
		formData.append("media", file);
		axios
			.post(
				`${API_MAP.WeddingStoryCover}?weddingId=${weddingID}`,
				formData,
				config
			)
			.then(({ data }) => {
				onSuccess("Ok");
				// console.log("upload server res: ", data);
				const { hasError } = data;
				if (hasError) {
					return Toast.fire({
						icon: "error",
						title: data.message,
					});
				}
				Toast.fire({
					icon: "success",
					title: data.message,
				});
				setDefaultFileList([]);
				setShowUpload(false);
				refetch();
				// message.success(data.message);
			})
			.catch((err) => {
				console.log("Error: ", err);
				onError({ err });
			});
	};

	// Upload media story content
	const [storyFileList, setStoryFileList] = useState([]);
	const [showStoryupload, setShowStoryUpload] = useState(true);

	const handleBeforeUpload = (file) => {
		// Processing file Change, guaranteed that the user selected by one is only one
		setStoryFileList([...storyFileList, file]);
		return true;
	};

	const handleStoryFileChange = ({ fileList }) => {
		setStoryFileList([...fileList]);
	};
	console.log(storyFileList);
	const handleStoryMediaUpload = async (options) => {
		if (isEmpty(storyFileList)) {
			return message.warning("Please select the file you want to upload");
		}
		if (isEmpty(weddingID)) {
			return Toast.fire({
				icon: "error",
				title: "Cant upload photo,\nWedding data not found",
			});
		}
		const formData = new FormData();
		formData.append("uuid", uuid_v4());
		storyFileList.forEach((file) => {
			formData.append(`media`, file);
		});
		const config = {
			headers: { "content-type": "multipart/form-data" },
		};
		setSaveContentLoad(true);
		axios
			.post(
				`${API_MAP.UploadStoryMedia}?weddingId=${weddingID}`,
				formData,
				config
			)
			.then(({ data }) => {
				// console.log("upload content media res: ", data.data);
				const { hasError } = data;
				if (hasError) {
					return Toast.fire({
						icon: "error",
						title: data.message,
					});
				}
				Toast.fire({
					icon: "success",
					title: data.message,
				});
				const { media_records } = data.data;

				if (editVisible) {
					const index = newStory.indexOf(selectedContent);
					newStory[index] = {
						url: media_records[0].media_url,
						type: "image",
					};
				} else {
					story.push({
						url: media_records[0].media_url,
						type: "image",
					});
				}
				setStoryFileList([]);
				setShowStoryUpload(false);
			})
			.catch((err) => {
				console.log("Error: ", err);
			})
			.finally(() => {
				setSaveContentLoad(false);
				setUnsavedAction(true);
			});
	};
	// Remove Image from array
	const handleRemove = (selectedFile) => {
		return storyFileList.filter((file) => {
			return selectedFile.uid !== file.uid;
		});
	};

	// Delete/Remove selected content
	const [selectedContent, setSelectedContent] = useState({});
	const [editContent, setEditContent] = useState({});
	const handleDelContent = (selected) => {
		if (selected === selectedContent) {
			setUnsavedAction(true);
			return setNewStory(
				newStory.filter((val) => {
					return selected !== val;
				})
			);
		}
	};

	// Story text content
	const [content, setContent] = useState("");
	const [loadAdd, setLoadAdd] = useState(false);

	// Add new content to existing story array
	const handleContent = (e) => {
		e.preventDefault();
		if (isEmpty(content)) {
			return;
		}
		setLoadAdd(true);
		story.push({ content: content, type: "text" });
		setTimeout(() => {
			message.success("Content added successfully");
			setLoadAdd(false);
			setContent("");
			setVisible(false);
			setUnsavedAction(true);
		}, 250);
	};

	const handleEditContent = (e) => {
		e.preventDefault();
		if (isEmpty(editContent)) {
			return;
		}
		setLoadAdd(true);
		const index = newStory.indexOf(selectedContent);
		newStory[index] = editContent;
		setTimeout(() => {
			message.success("Content updated successfully");
			setLoadAdd(false);
			setEditContent({});
			setVisible(false);
			setUnsavedAction(true);
		}, 250);
	};

	const handleEditUpdate = (e) => {
		e.preventDefault();
		if (story === newStory) {
			return setEditVisible(false);
		} else {
			setLoadAdd(true);
			setTimeout(() => {
				message.success("Please proceed to save changes now");
				setStory(newStory);
				setLoadAdd(false);
				setEditVisible(false);
				setUnsavedAction(true);
			}, 500);
		}
	};

	// Check if Add/Delete/Edit action has been saved
	const [unsavedAction, setUnsavedAction] = useState(false);
	const [saveContentLoad, setSaveContentLoad] = useState(false);
	useEffect(() => {
		if (unsavedAction) {
			window.onbeforeunload = () => true;
		} else {
			window.onbeforeunload = undefined;
		}
	}, [unsavedAction]);

	// Save story content to DB
	const handleSaveContent = async (e) => {
		e.preventDefault();
		setSaveContentLoad(true);
		const storyData = {
			story,
		};
		// console.log(storyData);
		try {
			const res = await addStoryContent(storyData);
			// console.log(res.data);
			const { hasError } = res.data;
			if (hasError) {
				return Toast.fire({
					icon: "error",
					title: "Error saving story",
				});
			}
			Toast.fire({
				icon: "success",
				title: res.data.message,
			});

			setUnsavedAction(false);
			refetch();
		} catch (error) {
			console.log("Error: ", error);
		} finally {
			setSaveContentLoad(false);
		}
	};

	const handleRevert = () => {
		setUnsavedAction(false);
		setSaveContentLoad(true);
		setTimeout(() => {
			setStory(coupleStory);
			setSaveContentLoad(false);
		}, 250);
	};

	const showModal = () => {
		setVisible(true);
	};

	return (
		<MainLayout>
			{saveContentLoad && <PageLoading />}
			<Prompt
				when={unsavedAction}
				message="You have unsaved changes, are you sure you want to leave?"
			/>

			<StoryWrapper css={hideScrollbar}>
				{/* Story Section */}
				<LandingTitle tw="text-2xl font-bold leading-8">
					Our story
				</LandingTitle>
				<div
					className="couple-name"
					tw="min-w-full p-6 mt-4 mb-4 flex flex-row flex-nowrap items-center justify-between gap-4">
					{" "}
					<div>
						{" "}
						<div tw="font-bold" style={{ fontSize: "15px" }}>
							{!isEmpty(couple) &&
								`${couple.groom_firstname} &
										${couple.bride_firstname}`}
						</div>
						<div tw="opacity-50" style={{ fontSize: "14px" }}>
							{bigDate}
						</div>
					</div>
					<div tw="flex flex-row flex-wrap gap-2">
						{unsavedAction && (
							<button
								onClick={handleSaveContent}
								tw=" px-4 py-2 shadow-md cursor-pointer rounded-lg text-xs text-white font-semibold bg-appPink border-none hover:(bg-appPinkSaturated)">
								Save Changes
							</button>
						)}
						{unsavedAction && (
							<Popconfirm
								placement="bottom"
								title={`Are you sure to undo all unsaved changes and revert to last saved? Note that you cannot undo this.`}
								onConfirm={() => handleRevert()}
								okText="Proceed"
								cancelText="Cancel">
								<button tw=" px-4 py-2 shadow-md cursor-pointer rounded-lg text-xs text-white font-bold bg-appPlaceholder border-none hover:(bg-appPinkSaturated)">
									Revert to Last Saved
								</button>
							</Popconfirm>
						)}
						{!isEmpty(story) && (
							<button
								onClick={showEditModal}
								tw="px-4 py-2 shadow-md cursor-pointer rounded-lg text-xs text-gray-700 font-semibold bg-gray-300 border-none hover:(bg-white)">
								Edit
							</button>
						)}
					</div>
				</div>
				<div tw="h-full w-full overflow-y-scroll" css={hideScrollbar}>
					<div
						className="jumbotron"
						// style={{ background: `url(${jumbo})` }}
						style={{
							background: `url(${
								couple?.story_cover_image_url || jumbo
							})`,
						}}
						tw="max-w-screen-lg shadow-md rounded-lg  text-center py-12 mt-4 flex justify-center items-center ">
						<Upload
							defaultFileList={defaultFileList}
							accept="image/*"
							onChange={handleFileChange}
							customRequest={handleUpload}
							maxCount={1}
							showUploadList={showupload}>
							{defaultFileList.length >= 1 ? null : (
								<Button
									size="large"
									tw="px-4 py-3 text-white border-none text-xs cursor-pointer font-semibold hover:(transform scale-105 text-appPink border! border-white!)"
									className="inner-cont">
									CHANGE COVER IMAGE
								</Button>
							)}
						</Upload>
					</div>

					<div
						tw="px-4 md:px-6 lg:px-8 py-4 bg-white min-w-full mt-4 rounded-2xl flex flex-col whitespace-pre-wrap gap-2 overflow-y-scroll"
						style={{ minHeight: "25vh" }}>
						{isEmpty(story) ? (
							<EmptyData
								description={
									<span tw="text-appPink font-semibold">
										No story content here!
									</span>
								}
							/>
						) : (
							story?.map((content, i) => {
								if (content.type === "image") {
									return (
										<div
											tw="flex flex-row items-center justify-center relative"
											key={i}>
											<Image
												src={content.url}
												alt={"image"}
												fallback={`data:image/png;base64,${fallbackString}`}
												tw="rounded-2xl shadow-md bg-gray-200 w-full h-96"
											/>
										</div>
									);
								}
								return (
									<p
										tw="text-sm text-left opacity-80"
										key={i}>
										{content.content}
									</p>
								);
							})
						)}
					</div>
					<hr style={{ border: "1px solid #ECECEC" }} />
					<div tw="mt-8 mb-4 flex flex-row md:flex-row gap-3">
						<Button
							size="large"
							className="btnStyle"
							tw="py-6 bg-white rounded inline-flex flex-nowrap items-center justify-between gap-2"
							onClick={showModal}>
							<span tw="opacity-60">Add text</span>
							<Image
								preview={false}
								src={plus}
								alt=""
								width={25}
								height={25}
							/>
						</Button>
						<Upload
							defaultFileList={storyFileList}
							accept="image/*"
							onChange={handleStoryFileChange}
							onRemove={handleRemove}
							action={handleStoryMediaUpload}
							beforeUpload={handleBeforeUpload}
							listType="picture"
							showUploadList={showStoryupload}>
							{storyFileList.length >= 10 ? null : (
								<Button
									size="large"
									className="btnStyle"
									tw="py-6 bg-white rounded inline-flex flex-nowrap items-center justify-between gap-2">
									<span tw="opacity-60">Upload image</span>
									<Image
										preview={false}
										src={plus}
										alt=""
										width={25}
										height={25}
									/>
								</Button>
							)}
						</Upload>
					</div>
					{/* {unsavedAction && (
					<Alert
						banner
						message={
							<TextLoop mask>
								<div>
									You currently have an unsaved content.
								</div>
								<div>Kindly save existing changes...</div>
							</TextLoop>
						}
					/>
				)} */}

					{/* Add story text modal */}
					<Modal
						footer=""
						visible={visible}
						centered
						onCancel={handleCancel}
						maskClosable={false}>
						{!editVisible && (
							<div tw="p-2">
								<LandingTitle tw="text-base font-semibold">
									Add story text
								</LandingTitle>
								<div tw="pt-4">
									<div>
										<TextArea
											placeholder="Write your beautiful story here"
											autoSize={{ minRows: 10 }}
											tw="mb-4 text-xs p-3 rounded-lg"
											value={content}
											onChange={(e) =>
												setContent(e.target.value)
											}
										/>
									</div>
									{/* <hr style={{ border: "1px solid #ececec7b" }} /> */}

									<div tw="mt-8 mb-8">
										<button
											css={btnStyle}
											onClick={handleContent}>
											{loadAdd ? <Loading /> : "Continue"}
										</button>
									</div>
								</div>
							</div>
						)}

						{editVisible && (
							<div tw="p-2">
								<LandingTitle tw="text-base font-semibold">
									Edit Story text
								</LandingTitle>
								<div tw="pt-4">
									<div>
										<TextArea
											placeholder="Write your beautiful story here"
											autoSize={{ minRows: 10 }}
											tw="mb-4 text-xs p-3 rounded-lg"
											value={editContent?.content}
											onChange={(e) =>
												setEditContent({
													...editContent,
													content: e.target.value,
												})
											}
										/>
									</div>

									<div tw="mt-8 mb-8">
										<button
											css={btnStyle}
											onClick={handleEditContent}>
											{loadAdd ? <Loading /> : "Continue"}
										</button>
									</div>
								</div>
							</div>
						)}
					</Modal>
					{/* End of story text modal */}

					{/* Edit story content modal */}
					<Modal
						footer=""
						visible={editVisible}
						centered
						width="100%"
						onCancel={handleEditCancel}
						maskClosable={false}>
						<div tw="p-2">
							<LandingTitle tw="text-2xl font-semibold">
								Edit story content
							</LandingTitle>
							<div tw="">
								<div
									tw="px-4 md:px-6 lg:px-8 py-4 bg-white min-w-full mt-4 rounded-2xl flex flex-col whitespace-pre-wrap gap-2 overflow-y-scroll"
									style={{ minHeight: "25vh" }}>
									{isEmpty(newStory) ? (
										<Empty
											description={
												<span tw="text-appPink font-semibold">
													No story content here!
												</span>
											}
										/>
									) : (
										newStory?.map((content, i) => {
											// console.log(content);
											if (content.type === "image") {
												return (
													<EditStyle
														hasBorder={editVisible}
														key={i}
														onClick={() => {
															setSelectedContent(
																content
															);
															setEditContent(
																content
															);
														}}>
														<div tw="flex flex-row items-center justify-center relative">
															<Image
																src={
																	content.url
																}
																alt={"image"}
																fallback={`data:image/png;base64,${fallbackString}`}
																tw="rounded-2xl shadow-md bg-gray-200 w-full h-96"
															/>
															<span tw="absolute left-5 -bottom-8 z-10! bg-white px-1">
																<Popconfirm
																	placement="top"
																	title={`Are you sure to delete this ${content.type}?`}
																	onConfirm={() =>
																		handleDelContent(
																			content
																		)
																	}
																	okText="Delete"
																	cancelText="Back">
																	<div>
																		<Image
																			preview={
																				false
																			}
																			src={
																				del
																			}
																			alt=""
																			width={
																				20
																			}
																			height={
																				20
																			}
																			tw=" hover:(bg-pink-200 p-0.5 rounded) cursor-pointer "
																		/>
																	</div>
																</Popconfirm>
															</span>
															<Upload
																defaultFileList={
																	storyFileList
																}
																accept="image/*"
																onChange={
																	handleStoryFileChange
																}
																onRemove={
																	handleRemove
																}
																action={
																	handleStoryMediaUpload
																}
																maxCount={1}
																beforeUpload={
																	handleBeforeUpload
																}
																listType="picture"
																// multiple
																showUploadList={
																	showStoryupload
																}>
																{storyFileList.length >=
																1 ? null : (
																	<span tw="absolute left-16 -bottom-9 z-10! bg-white px-1 rounded gap-2">
																		<Image
																			preview={
																				false
																			}
																			src={
																				upload
																			}
																			alt=""
																			width={
																				25
																			}
																			height={
																				25
																			}
																			tw="hover:(bg-pink-200 p-0.5 rounded) cursor-pointer"
																		/>
																	</span>
																)}{" "}
															</Upload>
														</div>
													</EditStyle>
												);
											}
											return (
												<EditStyle
													hasBorder={editVisible}
													key={i}
													onClick={() => {
														setSelectedContent(
															content
														);
														setEditContent(content);
													}}>
													<div tw="relative p-1">
														<p
															tw="text-sm text-left opacity-80"
															key={i}>
															{content.content}
														</p>
														<span tw="absolute left-10 -bottom-8 z-10! bg-white px-1">
															<Popconfirm
																placement="top"
																title={`Are you sure to delete this ${content.type}?`}
																onConfirm={() =>
																	handleDelContent(
																		content
																	)
																}
																okText="Delete"
																cancelText="Back">
																<div>
																	<Image
																		preview={
																			false
																		}
																		src={
																			del
																		}
																		alt=""
																		width={
																			20
																		}
																		height={
																			20
																		}
																		tw=" hover:(bg-pink-200 p-0.5 rounded) cursor-pointer "
																	/>
																</div>
															</Popconfirm>
														</span>
														<span tw="absolute left-20 -bottom-8 z-10! bg-white px-1 rounded gap-2">
															<Image
																preview={false}
																src={edit}
																alt=""
																width={20}
																height={20}
																tw=" hover:(bg-pink-200 p-0.5 rounded) cursor-pointer"
																onClick={
																	showModal
																}
															/>
														</span>
													</div>
												</EditStyle>
											);
										})
									)}
								</div>
							</div>
						</div>
						<hr style={{ border: "4px dotted #ececec" }} />
						<div tw="mt-8 mb-8">
							<button css={btnStyle} onClick={handleEditUpdate}>
								{loadAdd ? <Loading /> : "Continue"}
							</button>
						</div>
					</Modal>
					{/* End of edit story content modal */}
				</div>
			</StoryWrapper>
		</MainLayout>
	);
};

export default OurStory;
